module.exports = __webpack_public_path__ + "files/185fed254e6a942effe17eb77d13e8f6.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-1.png
// module id = 1620
// module chunks = 60